<div class="banner" role="banner">
  <h1>{{ 'games.page.pick.player.title' | translate }}</h1>
</div>

<div class="container">
  <div class="pick-a-player-bar d-flex my-4">
    <a
      [routerLink]="[backButtonLink]"
      class="text-primary flex-grow-0 flex-shrink-0 d-flex align-items-center justify-content-center fw-bold bg-grey select-player-back-btn"
    >
      <span class="material-symbols-outlined text-white"> arrow_back_ios_new </span>
    </a>
  </div>
  <div class="row my-3">
    <div class="col-lg-4 col-12">
      <fgb-fantasy-game-panel
        [game]="game$ | async"
        (button)="confirmSelection()"
        [buttonState]="button"
        [horizontal]="false"
      ></fgb-fantasy-game-panel>
    </div>
    <div class="col-lg-8 col-12">
      <div class="mt-3">
        <div class="row">
          <div class="col-lg-3 col-6" *ngFor="let player of players$ | async">
            <div class="card rounded overflow-hidden mb-3 border select-player-width" (click)="select(player.PlayerId)">
              <img alt="Player Picture" class="card-img-top border-bottom w-100" src="{{ player.Image | contentImage: '7' }}" />
              <div
                class="card-body d-flex justify-content-start align-items-center"
                [ngClass]="{ 'bg-primary text-white': player.IsSelected, 'text-black bg-white': !player.IsSelected }"
              >
                <div class="mx-auto mb-0 font-size-12 text-capitalize">{{ player.PlayerName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
